import { HttpParams } from '@angular/common/http';

export class SharedHelperService {
  constructor() {}

  convertObjectToParams(queries): any {
    let httpParams = new HttpParams();

    for (const key in queries) {
      if (queries.hasOwnProperty(key)) {
        httpParams = httpParams.append(
          key,
          typeof queries[key] !== 'string'
            ? JSON.stringify(queries[key])
            : queries[key]
        );
      }
    }
    return httpParams;
  }

  convertObjectAndArrayToParams(queries: any): any {
    let httpParams = new HttpParams();

    for (const key in queries) {
      if (queries.hasOwnProperty(key)) {
        const value = queries[key];

        if (Array.isArray(value)) {
          for (const item of value) {
            httpParams = httpParams.append(key, item);
          }
        } else {
          httpParams = httpParams.append(
            key,
            typeof value !== 'string' ? JSON.stringify(value) : value
          );
        }
      }
    }
    return httpParams;
  }
}
